import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    Ai_token: localStorage.getItem('Ai_token') ? localStorage.getItem('Ai_token') : '',
    Ai_userName: localStorage.getItem('Ai_userName') ? localStorage.getItem('Ai_userName') : '',
    Ai_userPhone: localStorage.getItem('Ai_userPhone') ? localStorage.getItem('Ai_userPhone') : '',
    Ai_userPost: localStorage.getItem('Ai_userPost') ? localStorage.getItem('Ai_userPost') : '',
  
  },
  mutations: {
    changeuser(state, user) {
      state.Ai_token = user.aiAdmin.aiUserAes;
      state.Ai_userName = user.aiAdmin.auName;
      state.Ai_userPhone = user.aiAdmin.auPhone;
      state.Ai_userPost = user.aiAdmin.auPost
      localStorage.setItem('Ai_token', user.aiAdmin.aiUserAes);
      localStorage.setItem('Ai_userName', user.aiAdmin.auName);
      localStorage.setItem('Ai_userPhone', user.aiAdmin.auPhone);
      localStorage.setItem('Ai_userPost', user.aiAdmin.auPost);

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
